import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'
import { FullScreenLoader } from '@/components/full-screen-loader'
import { useMe } from './use-me'

/** Gate for signed-in routes. Unknown → branded loader; signed out → /login. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const me = useMe()
  const location = useLocation()
  if (me.isPending) return <FullScreenLoader />
  if (!me.data) return <Navigate to="/login" replace state={{ from: location.pathname }} />
  return children
}

/** Login is only for signed-out visitors. */
export function GuestOnly({ children }: { children: ReactNode }) {
  const me = useMe()
  if (me.isPending) return <FullScreenLoader />
  if (me.data) return <Navigate to="/" replace />
  return children
}
